import { AuthService } from '@app/services/_index';
import { Injectable } from '@angular/core';
import { KeplerApiAuthorizerInterceptor } from './kepler-api-authorizer.interceptor';
import { environment } from '@environments/environment';

/**
 * Sets Kepler Docebo API requests with an Authorization header
 * necessary to verify the the current user's Okta JWT.
 */
@Injectable()
export class KeplerDoceboAuthorizerInterceptor extends KeplerApiAuthorizerInterceptor {
  constructor(authService: AuthService) {
    super(authService, environment.api.kepler.docebo.url);
  }
}
